
import { Component, Vue, namespace } from 'nuxt-property-decorator';
import FourwavesLogoFull from 'fourwaves-shared/src/images/fourwaves-dark-full.png';
import { TranslateResult } from 'vue-i18n';

const EventsModule = namespace('events');

@Component
export default class Footer extends Vue {
  @EventsModule.State eventId!: string;
  @EventsModule.State isWhiteLabel!: boolean;

  readonly FourwavesLogoFull = FourwavesLogoFull;

  readonly organizationLogos: Array<{ name: string; alt: string }> = [
    { name: 'university_of_florida', alt: 'University of Florida' },
    { name: 'texas_university', alt: 'University of Texas' },
    { name: 'yale_university', alt: 'Yale University' },
    { name: 'stanford_university', alt: 'Stanford University' },
    { name: 'mcgill_university', alt: 'McGill University' },
    { name: 'université_de_montreal', alt: 'Université de Montréal' },
    { name: 'université_de_sherbrooke', alt: 'Université de Sherbrooke' },
    { name: 'university_of_toronto', alt: 'University of Toronto' },
    { name: 'chu_sainte-justine', alt: 'CHU Sainte-Justine' },
    { name: 'crchum', alt: 'CRCHUM' },
    { name: 'aaas', alt: 'AAAS' },
    { name: 'csm', alt: 'CSM' },
  ];

  randomValue: number = 0;

  get variantName(): 'variantA' | 'variantB' {
    return this.randomValue > 0.5 ? 'variantA' : 'variantB';
  }

  get footerTitle(): TranslateResult {
    return this.$t(`footer.${this.variantName}.title`);
  }

  get ctaButtonLink(): TranslateResult {
    return this.$t(`footer.${this.variantName}.link`, { eventId: this.eventId });
  }

  public mounted(): void {
    this.randomValue = Math.random();
  }

  public footerVisibilityEnterHandler(): void {
    this.$eventBus.emit('footer:visibility-enter');
  }

  public footerVisibilityLeaveHandler(): void {
    this.$eventBus.emit('footer:visibility-leave');
  }
}
